import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

const PaymentSuccess = () => {
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const activateSubscription = async () => {
      try {
        // קריאת הפרמטרים מהכתובת
        const params = new URLSearchParams(window.location.search);
        const plan = params.get('plan') || 'monthly';

        // קבלת המשתמש המחובר
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) { setStatus('error'); return; }

        // חישוב תאריך סיום
        const endDate = new Date();
        endDate.setMonth(endDate.getMonth() + (plan === 'yearly' ? 12 : 1));

        // עדכון סופהבייס
        const { error } = await supabase
          .from('profiles')
          .update({
            is_subscribed: true,
            subscription_type: plan,
            subscription_end: endDate.toISOString(),
          })
          .eq('id', user.id);

        if (error) { setStatus('error'); return; }

        setStatus('success');
        setTimeout(() => { window.location.href = '/'; }, 3000);

      } catch (err) {
        setStatus('error');
      }
    };

    activateSubscription();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #fef3c7, #fce7f3)', fontFamily: 'sans-serif', direction: 'rtl', textAlign: 'center', padding: 20 }}>
      {status === 'processing' && (
        <div>
          <div style={{ fontSize: 50 }}>⏳</div>
          <h2>מפעילה את המנוי שלך...</h2>
        </div>
      )}
      {status === 'success' && (
        <div>
          <div style={{ fontSize: 60 }}>🎉🍦</div>
          <h2>המנוי הופעל בהצלחה!</h2>
          <p>מעבירה אותך לאתר בעוד 3 שניות...</p>
        </div>
      )}
      {status === 'error' && (
        <div>
          <div style={{ fontSize: 50 }}>😞</div>
          <h2>משהו השתבש</h2>
          <p>אנא צרי קשר: Yeshliglidasup@gmail.com</p>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;